import type { Appointment } from "@myapp/contract";

/**
 * A Termin that is done is not moved. Everything still ahead of it can be dragged to another slot
 * on the board.
 */
export const canReschedule = (a: Appointment) =>
  a.status !== "COMPLETED" && a.status !== "COMPLETED_WITH_FOLLOW_UP";

export const formatTime = (isoString: string): string => {
  const d = new Date(isoString);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const formatDuration = (minutes: number | null): string =>
  minutes != null ? `${minutes}` : "—";

/** `Anfahrt / Arbeit / Abfahrt`, the shape both layouts print durations in. */
export const formatDurationTriplet = (
  travel: number | null,
  work: number | null,
  departure: number | null,
): string =>
  `${formatDuration(travel)} / ${formatDuration(work)} / ${formatDuration(departure)}`;

/** The same triplet spelled out, for a `title` tooltip. */
export const durationTripletTitle = (
  travel: number | null,
  work: number | null,
  departure: number | null,
): string =>
  `Anfahrt: ${formatDuration(travel)} Min.\nArbeit: ${formatDuration(work)} Min.\nAbfahrt: ${formatDuration(departure)} Min.`;

export const isShowActualDuration = (a: Appointment) =>
  Boolean(
    a.schedule.actualWorkMinutes &&
      (a.status === "COMPLETED" || a.status === "COMPLETED_WITH_FOLLOW_UP"),
  );

export const isShowActualTime = (a: Appointment) => a.schedule.actualWorkStartsAt != null;

/** `08:05 / 09:10` — the real start and end, an em dash where one is still missing. */
export const formatActualRange = (a: Appointment): string => {
  const start = a.schedule.actualWorkStartsAt ? formatTime(a.schedule.actualWorkStartsAt) : "—";
  const end = a.schedule.actualEndsAt ? formatTime(a.schedule.actualEndsAt) : "—";
  return `${start} / ${end}`;
};
